// extracted by mini-css-extract-plugin
module.exports = {"text":"ContactingUs_text__JfxR4"};